import React, { Component } from 'react';
import ClipboardJS from 'clipboard';

/**
 * 텍스트 복사 컴포넌트. 오브젝트나 리스트가 넘어올 경우, JSON.stringify 한다.
 * 필요한 props는 아래와 같다.
 * target -> 클립보드에 복사할 타겟 오브젝트. String 권장
 * onSuccess() -> 클립보드 복사 성공후의 콜백함수
 * onError() -> 클립보드 복사 실패시의 콜백함수
 *
 * @author leegiwoong
 */
class Clipboard extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { wrapper } = this.refs;
        const { content, onSuccess, onError } = this.props;
        bindClipboardJS({wrapper, content, onSuccess, onError});
    }

    render() {
        const { children } = this.props;
        return (
            <div
                ref='wrapper'
            >
                {children}
            </div>
        );
    }
}

function bindClipboardJS({wrapper, content, onSuccess, onError} = {}) {
    const clipboard = new ClipboardJS(wrapper, {
        text: function() {
            if(content instanceof Object) {
                return JSON.stringify(content);
            }
            return content;
        }
    });

    clipboard.on('success', function(e) {
        console.info('Action:', e.action);
        console.info('Text:', e.text);
        console.info('Trigger:', e.trigger);
        onSuccess && onSuccess();
        e.clearSelection();
    });

    clipboard.on('error', function(e) {
        console.error('Action:', e.action);
        console.error('Trigger:', e.trigger);
        onError && onError();
    });
}

export default Clipboard;



// WEBPACK FOOTER //
// ./components/CommonSet/Clipboard.js